import { Chip } from '@mui/material';
import type { ChipProps } from '@mui/material/Chip';
import type { AssetTone, InventoryTone, UserTone } from '@/types/domain';

type Tone = AssetTone | InventoryTone | UserTone;

interface StatusChipProps {
  label: string;
  tone?: Tone;
  size?: ChipProps['size'];
}

const toneStyles: Record<Tone, { backgroundColor: string; color: string; borderColor: string }> = {
  success: {
    backgroundColor: '#dcfce7',
    color: '#166534',
    borderColor: '#86efac',
  },
  warning: {
    backgroundColor: '#fef3c7',
    color: '#92400e',
    borderColor: '#fcd34d',
  },
  error: {
    backgroundColor: '#fee2e2',
    color: '#991b1b',
    borderColor: '#fca5a5',
  },
  info: {
    backgroundColor: '#dbeafe',
    color: '#075985',
    borderColor: '#93c5fd',
  },
  neutral: {
    backgroundColor: '#e2e8f0',
    color: '#334155',
    borderColor: '#cbd5e1',
  },
};

export default function StatusChip({ label, tone = 'neutral', size = 'small' }: StatusChipProps) {
  const styles = toneStyles[tone];

  return (
    <Chip
      size={size}
      label={label}
      variant="outlined"
      sx={{
        backgroundColor: styles.backgroundColor,
        color: styles.color,
        borderColor: styles.borderColor,
        fontWeight: 700,
      }}
    />
  );
}